export const INFORMATION_TAB = 0;
export const CONTACT_TAB = 1;
export const EMPLOYMENT_TAB = 2;
export const FINANCIAL_TAB = 3;
export const DECLARATIONS_TAB = 4;
export const DEMOGRAPHICS_TAB = 5;
export const REAL_ESTATE_TAB = 6;
export const APPLICATION_TAB = 7;



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/tabNumbers.js